import { ApiError } from '@/lib/api/client'

// SOLY-INV-003 — the BE rejects a final invoice while the invoiced total exceeds
// the order (e.g. deposit issued before the order was amended down). Actionable
// message: the fix is a credit note, not retrying.
export const OVER_INVOICED_MESSAGE =
  'Le total déjà facturé dépasse le montant de la commande. Émettez d\'abord une note de crédit de la différence, puis générez la facture de solde.'

/** What to tell the user when an invoice could not be previewed or issued. */
export function invoiceErrorMessage(e: unknown, fallback: string): string {
  if (e instanceof ApiError && e.code === 'OVER_INVOICED') return OVER_INVOICED_MESSAGE
  // The server names the line and the limit; a generic failure would leave the user guessing.
  if (e instanceof ApiError && e.code === 'LINE_TEXT_TOO_LONG') return e.message
  return fallback
}
